<template>
    <div class="nzxt-bld-services">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 service-header t-center">
                    <h2 class="service-text text-upper">
                        NZXT and BLD services GO BEYOND
                    </h2>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 service-container">
                    <div class="service-item">
                        <div class="service-logo">
                            <img src="images/bulk-purchase/warranty.svg" alt="UCLA logo" width="61" height="64" class="img-responsive">
                        </div>
                        <div class="service-title">
                            <h3 class="text-upper">
                                2-Year<br>
                                Warranty
                            </h3>
                        </div>
                        <div class="service-description">
                            <p>
                                Free 2-year warranty on all parts &amp; labor as<br>
                                well as professional wire management.
                            </p>
                        </div>
                    </div>
                    <div class="service-item">
                        <div class="service-logo">
                            <img src="images/bulk-purchase/pcdiy.svg" alt="UCLA logo" width="61" height="64" class="img-responsive">
                        </div>
                        <div class="service-title">
                            <h3 class="text-upper">
                                High Quality<br>
                                Builds
                            </h3>
                        </div>
                        <div class="service-description">
                            <p>
                                Our curated inventory is rigorously tested<br>
                                to ensure they are the best out there.
                            </p>
                        </div>
                    </div>
                    <div class="service-item">
                        <div class="service-logo">
                            <img src="images/bulk-purchase/heart.svg" alt="UCLA logo" width="61" height="64" class="img-responsive">
                        </div>
                        <div class="service-title">
                            <h3 class="text-upper">
                                Award winning<br>
                                customer service
                            </h3>
                        </div>
                        <div class="service-description">
                            <p>
                                Our mission is to provide winning solutions<br>
                                in response to customer requests.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row request-builds-container">
                <div class="request-builds">
                    <button class="btn btn-block text-upper request-builds-btn" @click="scrollToForm">
                        Get in touch
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "NzxtBldServices",
    methods: {
        scrollToForm() {
            this.$emit("scrollToRef", "bulk-purchase-form");
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

/* MOBILE */
.nzxt-bld-services {
    padding: 29px 0 38px;

    .service-header {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        padding-bottom: 39px;
        color: $dark;

        .service-text {
            font-size: 36px;
        }
    }
    .service-container {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-evenly;
        padding: 10px;

        .service-item {
            flex-basis: 100%;
            display: flex;
            flex-flow: row wrap;
            justify-content: center;
            align-items: center;
            padding: 0 10px;

            .service-logo {
                flex-basis: 100%;
                display: flex;
                justify-content: center;
            }

            .service-title {
                flex-basis: 100%;
                color: #444259;
                text-align: center;
                line-height: 21px;
            }

            .service-description {
                flex-basis: 100%;
                color: #5F707F;
                line-height: 21px;
                text-align: center;
                margin-bottom: 32px;
            }
        }
    }

    .request-builds-container {
        display: flex;
        justify-content: center;
        align-items: center;

        .request-builds {
            flex-basis: 90%;

            .request-builds-btn {
                font-family: "Akkurat-normal", sans-serif;
                line-height: 19px;
                font-size: 18px;
            }
        }
    }
}

/* TABLET */
@media screen and (min-width: 768px) {
    .nzxt-bld-services {
        padding-top: 50px;
        padding-bottom: 64px;

        .service-header {
            padding-bottom: initial;
        }

        .service-container {
            padding-top: 70px;
            padding-bottom: 40px;

            .service-item {
                flex-basis: 32%;
                padding: initial;

                .service-description p br {
                    display: none;
                }
            }
        }

        .request-builds-container .request-builds {
            flex-basis: 40%;
        }
    }
}
/* TABLET & DESKTOP */
@media screen and (min-width: 1024px) {
    .nzxt-bld-services {
        .service-container {
            justify-content: space-around;

            .service-item {
                flex-basis: 30%;
                padding: initial;
            }
        }

        .request-builds-container .request-builds {
            flex-basis: 35%;
        }
    }
}
/* DESKTOP */
@media screen and (min-width: 1366px) {
    .nzxt-bld-services .service-container .service-item .service-description p br {
        display: initial;
    }
}
</style>